/* eslint-disable */
import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import 'contents/assets/scss/page/teacher.scss';
import Tab from '../../../component/Inc/Tab';
import Paging from '../../../component/Inc/Paging';
import PopMentoring from '../_PopMentoring';
import PopApproval from '../_PopApproval';
function TeacherPreparing() {
  const [isOrderActive1, setIsOrderActive1] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '전체', value: 0},
    {title: '미배정 교사', value: 1},
    {title: '첫 배정 교사', value: 2},
    {title: '두번째 배정 교사', value: 3},
    {title: '특별 관리 교사', value: 4},
    {title: '맨토 미배정', value: 5, type: ' red'},
    {title: '교육 진행중', value: 6},
    {title: '완료', value: 7}
  ];
  const [modalMentoring, setModalMentoring] = useState(false);
  const [modalApproval, setModalApproval] = useState(false);
  return (
    <main className="com_container p_mentor_report">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu2_9">멘토링</h2>
          <div className="com_btn_wrap">
            <Link to="/Teacher/Mentoring/Manage" className="com_btn orange s btn_settings">
              멘토 관리
            </Link>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} tabStyle="fit_cont" />
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <div className="board_select">
                <div className="check">
                  <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                  <label htmlFor="rdo01">전체</label>
                  <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                  <label htmlFor="rdo02">국어</label>
                  <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                  <label htmlFor="rdo03">영어</label>
                  <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                  <label htmlFor="rdo04">수학</label>
                  <input type="radio" name="rdo" id="rdo05" className="com_chk circle" />
                  <label htmlFor="rdo05">과탐</label>
                  <input type="radio" name="rdo" id="rdo06" className="com_chk circle" />
                  <label htmlFor="rdo06">사탐</label>
                  <input type="radio" name="rdo" id="rdo07" className="com_chk circle" />
                  <label htmlFor="rdo07">수시</label>
                </div>
              </div>
              <section className="com_board_search end">
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <button className="com_btn gray s">조회</button>
                </div>
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="70" />
                <col width="133" />
                <col width="133" />
                <col width="133" />
                <col width="133" />
                <col width="auto" />
                <col width="133" />
                <col width="133" />
                <col width="133" />
                <col width="170" />
                <col width="133" />
              </colgroup>
              <thead>
                <tr>
                  <th>No</th>
                  <th>가입일</th>
                  <th>교사명</th>
                  <th>과목</th>
                  <th>학생</th>
                  <th>
                    첫수업 일시&nbsp;
                    <button
                      onClick={() => {
                        setIsOrderActive1(!isOrderActive1);
                      }}
                      className={`arrow ${isOrderActive1 ? `active` : ``}`}
                    />
                  </th>
                  <th>학생 전화번호</th>
                  <th>담임</th>
                  <th>승인</th>
                  <th>멘토</th>
                  <th>멘토 보고서</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>2023, 05, 10</td>
                  <td>
                    <button className="btn_link">홍길동101</button>
                  </td>
                  <td>국어</td>
                  <td>
                    홍길동101
                  </td>
                  <td className="com_blue_txt">2023, 05, 10 20:30</td>
                  <td className="bg_col">010-1234-1344</td>
                  <td className="bg_col">
                    <button className="btn_link">김담임 103</button>
                  </td>
                  <td>
                    <button onClick={() => setModalApproval(true)} className="btn_link red">
                      승인 요청
                    </button>
                  </td>
                  <td>
                    <button onClick={() => setModalMentoring(true)} className="btn_link red">
                      맨토 미배정
                    </button>
                  </td>
                  <td>
                    <button className="btn_link blue">보기</button>
                  </td>
                </tr>
                {[2, 3, 4, 5].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>2023, 05, 10</td>
                      <td>
                        <button className="btn_link">홍길동101</button>
                      </td>
                      <td>국어</td>
                      <td>
                        홍길동101
                      </td>
                      <td>2023, 05, 10 20:30</td>
                      <td className="bg_col">010-1234-1344</td>
                      <td className="bg_col">
                        <button className="btn_link">김담임 103</button>
                      </td>
                      <td>
                        김교무123
                        <br />
                        2023, 05, 12
                      </td>
                      <td>
                        홍멘토101
                        <br />
                        010-1234-1234
                      </td>
                      <td>
                        <button className="btn_link blue">보기</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
        </section>
      </div>
      <PopMentoring open={modalMentoring} close={() => setModalMentoring(false)} />
      <PopApproval open={modalApproval} close={() => setModalApproval(false)} />
    </main>
  );
}
export default TeacherPreparing;
